<template>
  <div>
    <section class="main-content">

      <div class="inner-banner inner-banner-bg">
          <div class="container">
              <div class="articles-box">
                  <figure class="pic articles-pic fitimg mb-0">
                      <img class="img-fluid" src="https://admin.weddingsung.com/upload/slide/88311b59e2e2c107d44366e24d81f644.png" />
                  </figure>
                  <!-- <div class="text">
                      <h4 class="title text-primary">{{this.getCategory.title}}</h4>
                      <p class="txt"  v-html="this.getCategory.context"></p>
                  </div> -->
              </div>
          </div>
      </div>

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-bird"><span>相關夥伴 {{this.getCategory.title}}</span></h3>
                            <div class="articles-items">

                                <div class="row strict7">

                                    <div class="col-md-3 col-sm-4"  v-for="(row, index) in partner">
                                        <div class="articles-box news-box">
                                            <a :href="row.link" target="_blink">
                                                <figure class="articles-fitimg">
                                                    <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/partner/'+row.image_path" />
                                                </figure>
                                                <div class="text text-center">
                                                    <h5 class="title text-primary">{{row.title}}</h5>
                                                    <p class="txt" v-html="row.context"></p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'partner',
  data () {
    return {
      uri: this.$store.getters.getUri,
      partner: [],
      categoryId: 0
    }
  },
  computed: {
    ...mapGetters([
      'getUri'
    ]),
    getCategory () {
      return this.$store.getters.getPartnerCategory[this.$route.params.id - 1]
    }
  },
  mounted: function () {
    this.categoryId = this.$route.params.id
    this.searching()
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    searching () {
      let self = this
      if (this.categoryId !== '') {
        this.$http.get(this.uri + 'Partner/get_partners_by_category/' + this.categoryId).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            self.partner = data.partners
          } else {
            console.log('下載夥伴資料失敗')
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Partner.vue?63a860e3